
import Editor from "./boxComponents/Editor";
import { less } from "@codemirror/lang-less";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCaretLeft, faSquareCaretRight, faSquareCaretUp, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";

const CSSBox = ({ cStyle, icon, value, codeFunction, cWidth, onHandleClick, toggle, mousecaptuerEvent, viewPosition }) => {
    const [toggle1, toggle2, toggle3] = toggle;
    const divStyle = {
        ...cStyle[0],
        width: viewPosition ? "100%" : cWidth[1] ? `calc(${cStyle[0].width} + ${cWidth[1]}px)` : cStyle[0].width,
        height: viewPosition ? `calc(${cStyle[0].height} + ${cWidth[1]}px)` : cStyle[0].height,
        icon: {
            color: "rgb(14, 190, 255)"
        },

        boxStyle: !toggle1 && !toggle3 ? { ...cStyle[1] } : viewPosition ? { ...cStyle[1] } : { ...cStyle[2] }
    }


    return (
        <div style={divStyle} id="css">
            <div style={divStyle.boxStyle} onMouseDownCapture={mousecaptuerEvent}>
                <div style={divStyle.boxStyle.textDiv}>
                    <FontAwesomeIcon icon={icon} style={divStyle.icon} />
                    {toggle1 === true || toggle3 === true ? null : <h3 style={divStyle.boxStyle.h3}>css</h3>}
                </div>
                <FontAwesomeIcon icon={viewPosition ? toggle2 ? faSquareCaretDown : faSquareCaretUp : toggle2 ? faSquareCaretLeft : faSquareCaretRight} style={divStyle.boxStyle.button} onClick={onHandleClick} />
            </div>
            <Editor language={less} value={value} onChange={codeFunction} />
        </div>
    );
}

export default CSSBox;